import React from 'react';
import ReactDOM from 'react-dom/client';
import Sentry from './lib/sentry';
import App from './App';

function GlobalFallback() {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '100vh', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      background: '#f5f5f5', color: '#333', textAlign: 'center', padding: '2rem'
    }}>
      <div>
        <h1 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Something went wrong</h1>
        <p style={{ color: '#666', marginBottom: '1.5rem' }}>
          An unexpected error occurred. Please try reloading the page.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: '0.5rem 1.5rem', fontSize: '0.9rem', cursor: 'pointer',
            background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '6px',
            marginRight: '1rem'
          }}
        >
          Reload page
        </button>
        <a
          href="/login"
          style={{ color: '#4f46e5', fontSize: '0.9rem', textDecoration: 'underline' }}
        >
          Go to sign in
        </a>
      </div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Sentry.ErrorBoundary fallback={<GlobalFallback />}>
    <App />
  </Sentry.ErrorBoundary>
);
